/**
 * Container component inspired by Park UI's design system
 */

import React from "react";
import { css } from "../../lib/panda";
import { presets } from "../../styles";

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg" | "xl" | "full";
  children: React.ReactNode;
}

const containerSizes = {
  sm: css({
    maxWidth: "640px",
    margin: "0 auto",
    padding: "0 1rem",
  }),
  md: css({
    maxWidth: "768px",
    margin: "0 auto",
    padding: "0 1.5rem",
  }),
  lg: css({
    maxWidth: "1024px",
    margin: "0 auto",
    padding: "0 1.5rem",
  }),
  xl: css({
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 1.5rem",
  }),
  full: presets.container.fluid,
};

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ size = "lg", children, className, style, ...props }, ref) => {
    const containerStyles = css(containerSizes[size], style);

    return (
      <div ref={ref} style={containerStyles} {...props}>
        {children}
      </div>
    );
  }
);

Container.displayName = "Container";
